import getProgress from './get-progress';

export { getProgress };

export default getProgress;
